export const caas_dummy_content: any = {
  "data": {
    "duplicateStatementsConfirmationsFlowPageContainer": {
      "item": {
        "_path": "/content/dam/content-fragments/client-experiences/us/en/profile-account-settings/mail-alert-settings/duplicate-statements-confirms/page-containers/duplicate-statements-confirmations-flow-page-container",
        "heading": null,
        "additionalHeadings": null,
        "subheading": null,
        "additionalSubheadings": null,
        "body": [],
        "icon": null,
        "image": null,
        "imageAltText": null,
        "thumbnail": null,
        "thumbnailAltText": null,
        "messages": [
          {
            "_path": "/content/dam/content-fragments/client-experiences/us/en/profile-account-settings/mail-alert-settings/duplicate-statements-confirms/error-messages/int-poid-not-present-error-message",
            "heading": "Something went wrong",
            "additionalHeadings": null,
            "subheading": null,
            "additionalSubheadings": null,
            "body": [
              {
                "html": "POID is not present in the cookie. Please do a \u003cb\u003eclient search again\u003c/b\u003e.\n"
              }
            ],
            "icon": null,
            "image": null,
            "imageAltText": null,
            "thumbnail": null,
            "thumbnailAltText": null
          }
        ],
      }
    }
  }
}
